<template>
  <button :class="[$style.button, fill ? $style.fill : false]">
    <span>
      <slot />
    </span>
  </button>
</template>

<script>
export default {
  props: ['fill']
}
</script>


<style module lang="scss">
.button {
  position: relative;
  color: $color-blue;
  background: transparent;
  margin: 10px 0;
  padding: 20px 100px;
  text-transform: uppercase;
  border: 0;
  font-size: font-size(s);
  font-weight: 600;
  letter-spacing: 3px;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(.17,.67,.59,.85);

  &.fill {
    background: $color-blue;
    color: white;

    &::after,
    &::before,
    span::after,
    span::before {
      background: white;
    }
  }

  &:focus {
    outline: none;
  }

  :global(.no-touchevents) &:hover {
    color: white;

    &::after,
    &::before {
      transform: scale(0, 1);
    }

    span::after,
    span::before {
      transform: scale(1, 0);
    }
  }

  &::after,
  &::before {
    content: "";
    position: absolute;
    width: 100%;
    height: 1px;
    left: 0;
    background: $color-blue;
    transition: all 0.4s cubic-bezier(.17,.67,.59,.85);
  }

  &::before {
    top: 0;
    transform-origin: 0;
  }

  &::after {
    bottom: 0;
    transform-origin: 100%;
  }

  span {
    &::after,
    &::before {
      content: "";
      position: absolute;
      width: 1px;
      height: 100%;
      top: 0;
      background: $color-blue;
      transition: all 0.4s cubic-bezier(.17,.67,.59,.85);
    }

    &::before {
      left: 0;
      transform-origin: 0 0;
    }

    &::after {
      right: 0;
      transform-origin: 100% 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Cta.vue